import { useRef } from 'react';

import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Flex } from '@revenuemarket/cds';
import { Colors, PrimaryColors, typographyStyle } from '@revenuemarket/design';
import { unique } from '@revenuemarket/utils/arrayUtils';
import { Checkbox, Typography } from 'antd';
import { GroupTreeItem } from '~apis/custom-label';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';
import { css } from '~libs/emotion';

// TODO: Refactor to resolve circular dependency
// oxlint-disable-next-line import/no-cycle
import { getDepthStyle } from '.';

interface Props {
  multiple: boolean;
  targetIndex: number;
  node: FlattenTreeResult<GroupTreeItem>;
  handleActiveKey: ({
    targetKey,
    node,
    selected,
  }: {
    targetKey: string;
    node: FlattenTreeResult<GroupTreeItem>;
    selected?: boolean;
  }) => void;
  activeKey: string[] | null;
  setActiveKey: React.Dispatch<React.SetStateAction<string[] | null>>;
  disabled?: boolean;
  closeOnSelect?: boolean;
  onSelect?: (value: string | number, key: string[]) => void;
}

const GroupTreeDropDownItem: React.FC<Props> = ({
  multiple,
  targetIndex,
  node,
  handleActiveKey,
  activeKey,
  setActiveKey,
  closeOnSelect,
  disabled,
  onSelect,
}) => {
  const selected = node.value?.id ? activeKey?.includes(node.value?.id.toString()) : false;

  const firstMenuItemRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={targetIndex === 0 ? firstMenuItemRef : null}
      tabIndex={-1}
      role="menuitem"
      data-key={node.key}
      className={css`
        &:focus-visible {
          outline: none;
        }
      `}
      onClick={(e) => {
        if (!closeOnSelect) e.stopPropagation();
      }}
      onKeyDown={(e) => {
        // enter key를 누르면 선택한다.
        if (e.key === 'Enter') {
          //e.currentTarget 의 data-key를 뽑아온다
          const targetKey = e.currentTarget.getAttribute('data-key');

          handleActiveKey({
            targetKey: targetKey ?? '',
            node,
            selected,
          });
        }
      }}
    >
      <Flex
        justify="space-between"
        style={{
          width: '100%',
        }}
      >
        <Flex
          gap={2}
          style={{
            width: 'calc(100% - 90px)',
          }}
          onClick={(e) => {
            if (!closeOnSelect) e.stopPropagation();

            handleActiveKey({
              targetKey: node.key,
              node,
              selected,
            });
          }}
          className={getDepthStyle(node.colIndex)}
        >
          {multiple ? <Checkbox checked={activeKey?.includes(node.key)} /> : <div />}
          <Typography.Text
            style={{
              ...typographyStyle['14_400'],
              width: '100%',
              color:
                disabled || (node.value?.id.toString() === '0' && !multiple)
                  ? Colors.gray400
                  : activeKey?.includes(node.key)
                    ? PrimaryColors.primary500
                    : Colors.gray700,
            }}
          >
            {node.value?.name}
          </Typography.Text>
          {!node?.value?.isActive && (
            <MinusCircleOutlined
              width={18}
              height={18}
              style={{
                color: Colors.gray400,
              }}
            />
          )}
        </Flex>
        {node.children?.length > 0 && multiple ? (
          <Button
            border
            onClick={(e) => {
              e.stopPropagation();
              if (selected) {
                const filteredKeys = activeKey?.filter((key) => key !== node.key) ?? [];
                setActiveKey(filteredKeys);

                onSelect?.(node.value?.id ?? '', filteredKeys);
              } else {
                const filteredKeys = unique([...(activeKey ?? []), node.key]);

                setActiveKey(filteredKeys);
                onSelect?.(node.value?.id ?? '', filteredKeys);
              }
            }}
            buttonSize="small"
            style={{
              padding: '0 8px',
            }}
          >
            <Typography.Text
              style={{
                ...typographyStyle['13_400'],
              }}
            >
              {`개별 선택 ${selected ? '해제' : ''}`}
            </Typography.Text>
          </Button>
        ) : (
          <div />
        )}
      </Flex>
    </div>
  );
};

export default GroupTreeDropDownItem;
